import { Box, Center } from "@chakra-ui/layout"
import React, { ReactNode } from "react"

import Typography from "~/components/atoms/Typography"
import { Color, RadiusSize, SpacingSize } from "~/consts/style-mixins"

type Props = {
  title: string | ReactNode
}

export const Section: React.FC<Props> = ({ children, title }) => {
  return (
    <Center px={SpacingSize.M} py={SpacingSize._2XL} bgColor={Color.White} borderRadius={RadiusSize.Medium}>
      <Box w={480}>
        <Box textAlign="center">
          <Typography type="Heading">{title}</Typography>
        </Box>
        <Box mt={SpacingSize.M}>{children}</Box>
      </Box>
    </Center>
  )
}
